var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 10.94h.41v4H6v.42H4z","key":0}),React.createElement("path",{"d":"M6 11h.44l1.34 3.41L9.18 11h.44l-1.76 4.36h-.09z","key":1}),React.createElement("path",{"d":"M11.62 15.34h-2v-.43h1.55v-4h.41z","key":2}),React.createElement("path",{"className":"level-2","d":"M13.84 9.36a3.13 3.13 0 01.7-1.94L13.26 6A4.94 4.94 0 0012 9.31v.43h1.83z","key":3}),React.createElement("path",{"className":"level-2","d":"M20 16h-4.54l2.17-2.43c.48-.56.87-1.05 1.18-1.49l-1.3-1.42c-.3.44-.76 1-1.38 1.76L11.22 18h6.93z","key":4})]);
}

Logo.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Logo;

Logo.default = Logo;
